import { Form, Formik } from "formik";
import * as React from "react";
import * as yup from "yup";
import TextArea from "../core/TextArea";
import Card from "../core/Card";
import TextField from "../core/TextField";
import Button from "../core/Button";
import { createTicket } from "../../libs/chartec_cw";
import toast from "../../utils/toast";
import Panel from "../core/Panel";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validationSchema = yup.object().shape({
  name: yup.string().required("Name Required"),
  email: yup
    .string()
    .email("Invalid email")
    .required("Email Required"),
  phone: yup
    .string()
    .matches(phoneRegExp, "Invalid Phone")
    .nullable(true),
  description: yup.string().required("Description required"),
});

export function defaultFormValues(userData: any) {
  return {
    name: userData.name === null ? "" : userData.name,
    title: userData.jobTitle === null ? "" : userData.jobTitle,
    email: userData.email === null ? "" : userData.email,
    phone: userData.phoneNumber === null ? "" : userData.phoneNumber,
    description: "",
  };
}

export function CoachesForm(props: {
  setSubmitted: () => void;
  userData: any;
  cwCompanyId: string;
  cwRecId: string;
}) {
  return (
    <Formik
      initialValues={defaultFormValues(props.userData)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={async (values, formikActions) => {
        const { setSubmitted, userData, cwCompanyId, cwRecId } = props;
        document.getElementById("transition-overlay")!.style.display = "block";
        const params = {
          companyid: cwCompanyId ? cwCompanyId : "",
          subject: `Core - Coaches Center Request -  ${values.name}`,
          message: `Coaches center request from:
                    \n name: ${values.name}
                    \n title: ${values.title}
                    \n email: ${values.email}
                    \n phone: ${values.phone}
                    \n\n message: ${values.description}`,
          board: "account management",
          recid: cwRecId ? Number(cwRecId) : null,
        };
        const status = await createTicket(params).catch(error =>
          toast.error(`Unable to process submit: ${error}`)
        );
        document.getElementById("transition-overlay")!.style.display = "none";
        if (status.result === "created") {
          toast.success("Successfully created request");
          formikActions.resetForm(defaultFormValues(userData));
          setSubmitted();
        } else {
          toast.error(`Unable to process submit, try again later`);
        }
      }}
      render={({ values, errors, touched, handleChange, isSubmitting }) => (
        <Form>
          {errors.name || errors.phone || errors.email || errors.description ? (
            <Card title={"Errors"}>
              <ul>
                {Object.keys(errors).map((k, i) => (
                  <li key={i} style={{ color: "red" }}>
                    {errors[k]}
                  </li>
                ))}
              </ul>
            </Card>
          ) : null}
          <TextArea
            label={"How Can We Help?"}
            name={"description"}
            value={values.description}
            onChange={handleChange}
            error={
              errors.description ? errors.description.toString() : undefined
            }
            required={true}
          />
          <hr />
          <Panel heading={"Your Contact Info"}>
            <TextField
              label={"Name"}
              type={"text"}
              name={"name"}
              value={values.name}
              onChange={handleChange}
              error={errors.name ? errors.name.toString() : undefined}
              required={true}
            />
            <TextField
              label={"Title"}
              type={"text"}
              name={"title"}
              value={values.title}
              onChange={handleChange}
              error={errors.title ? errors.title.toString() : undefined}
              required={false}
            />
            <TextField
              label={"Email"}
              type={"email"}
              name={"email"}
              value={values.email}
              onChange={handleChange}
              error={errors.email ? errors.email.toString() : undefined}
              required={true}
            />
            <TextField
              label={"Phone"}
              type={"text"}
              name={"phone"}
              value={values.phone}
              onChange={handleChange}
              error={errors.phone ? errors.phone.toString() : undefined}
              required={false}
            />
            <br />
          </Panel>
          <Button
            disabled={isSubmitting}
            type={"submit"}
            loading={isSubmitting}
          >
            {" "}
            Submit{" "}
          </Button>
        </Form>
      )}
    />
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/coaches/CoachesForm.tsx